import { Avatar, Button, Stack, Typography } from '@mui/material';
import { ILastClaimEventEntries, getLastClaimEventEntries } from 'API';
import { useAppSelector, useDictionary, useIsDesktop } from 'Hooks';
import { useCallback, useEffect, useState } from 'react';
import { CustomDivider } from '../Utils/CustomDivider';
import { useNavigate } from 'react-router-dom';
import { BigButton } from 'Images';
import { ClaimEvent } from './ClaimEvent';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';

export const UserRecognitionStatus = () => {
  const [lastClaimEventEntries, setLastClaimEventEntries] = useState<
    ILastClaimEventEntries[]
  >([]);
  const imposterId = useAppSelector(
    ({ imposter: { imposterId } }) => imposterId
  );

  const navigate = useNavigate();
  const MAX_CLAIM_EVENTS_LIMIT = 1;
  const dictionary = useDictionary(Dictionary, DICTIONARY.Home).userClaimEvents;
  const isDesktop = useIsDesktop();

  const initRecognitionStatus = useCallback(async () => {
    const lastClaimEventsEntriesResult = await getLastClaimEventEntries();
    if (lastClaimEventsEntriesResult)
      setLastClaimEventEntries(lastClaimEventsEntriesResult);
  }, []);

  useEffect(() => {
    initRecognitionStatus();
  }, [initRecognitionStatus, imposterId]);

  if (lastClaimEventEntries.length === 0) return null;

  return (
    <Stack>
      <Typography variant='h5' component={'h2'}>
        {dictionary.title}
      </Typography>
      <CustomDivider />
      <Stack
        direction={isDesktop ? 'row' : 'column'}
        gap={isDesktop ? '16px' : '20px'}
        sx={{
          m: '12px 0',
        }}
      >
        {lastClaimEventEntries.map(
          (claimEvent: ILastClaimEventEntries, index: number) => {
            if (index > MAX_CLAIM_EVENTS_LIMIT) return null;
            return <ClaimEvent key={index} claimEvent={claimEvent} />;
          }
        )}
      </Stack>
      {lastClaimEventEntries.length > MAX_CLAIM_EVENTS_LIMIT && (
        <Button
          onClick={() => navigate('/recognitionStatus')}
          sx={{ p: 0, width: 'fit-content', m: '0 auto' }}
          endIcon={
            <Avatar
              sx={{
                height: '50px',
                width: '46px',
                mt: '6px',
              }}
              src={BigButton}
              alt=''
            />
          }
        >
          <Typography variant='body5'>{dictionary.allClaimEvents}</Typography>
        </Button>
      )}
    </Stack>
  );
};
